import { FlexflowCardStatus, FlexflowEmployeeStatuses } from '../types';
import { type FlexflowEmployeeDataToDisplay } from '../Contracts/types';
import { FOOD_MAX_LIMIT_AMOUNT, TRANSPORT_MAX_LIMIT_AMOUNT } from '../EmployeeDetails/CategoriesGroup/Form/FormContent';

type UpdateStatusIfNeededArgs = {
  data: FlexflowEmployeeDataToDisplay;
  suspendedByLimit: boolean;
};

export const updateStatusIfNeeded = ({ data, suspendedByLimit }: UpdateStatusIfNeededArgs) => {
  const newData = { ...data };

  if (suspendedByLimit) {
    return {
      ...newData,
      status: FlexflowEmployeeStatuses.DISABLED,
      card: { ...newData.card, status: FlexflowCardStatus.SUSPENDED }
    };
  }

  return newData;
};
